import {IconConfig} from "../models/icon.config";

export interface FieldAffix {
    tooltip?: string;
    icon: string | IconConfig;
    click?: () => {};
    readonly?: boolean;
}

